import { searchNewsroom as newsroomMapper } from '../helpers/filters/newsroom';
import { search } from './search';

export const FILTER_NEWSROOM_KEY = 'newsroom-filter';
export const searchNewsroom = search(newsroomMapper);
